import React, { useEffect, useRef, useState } from 'react'
import ProductItem from './unique store items/Product-Item'
import axios from 'axios';
import { API_CONFIG, API_HEADERS } from '../../../network/config/ApiConfig';
import { STORE_API_PATH } from '../../../network/config/apiPaths';
import { useIsAccountent, useIsCustomerSupport, useIsFranchisLogin, useIsSuperAdmin } from '../../../utils/userRoles';
import { consoleLog } from '../../../utils/log-utils';
import { useNavigate } from 'react-router-dom';
import AppPagination from "../../../components/pagination";

function UniqueStoreProducts(props) {
  const isFranchise = useIsFranchisLogin();
  const isCustomerSupport = useIsCustomerSupport();
  const isAccountent = useIsAccountent();
  const [productsList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("");
  const [filterList, setFilterList] = useState([])

  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [pageOffset, setPageOffset] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const isFirstRender=useRef(true);
  const isSuperAdmin=useIsSuperAdmin();

  const navigate = useNavigate();


  useEffect(() => {
    consoleLog("id..", props.id)
    if(isFirstRender.current){
      StoreProductsApi(searchValue,pageLimit,pageOffset);
      isFirstRender.current=false;
    }
  //  else{
  //   StoreProductsApi();
  //  }

  }, [totalCount, pageLimit, activePage])

  //  useEffect(() => {
  //     consoleLog("id..", props.id)
  //     if(searchValue===""){
  //       StoreProductsApi();
  //     }
  //     // &&totalCount==0&&pageLimit==20&&activePage==1
  //    else if(searchValue!==""){
  //       storeProductSearch();
  //      }
  //     //  ||totalCount!==0||pageLimit!==20||activePage!==1
  //   }, [searchValue,totalCount,pageLimit,activePage])


  // useEffect(()=>{
  //    if(searchValue!==""||totalCount!==0||pageLimit!==20||activePage!==1){
  //     storeProductSearch();
  //    }
  // },[searchValue,totalCount,pageLimit,activePage])

  const handlePageChange = (selectedPage) => {
    setActivePage(selectedPage);
    setPageOffset((selectedPage - 1) * pageLimit);
    StoreProductsApi(searchValue,pageLimit,((selectedPage - 1) * pageLimit));
  };

  const handleLimitChange = (e) => {
    setPageLimit(e.target.value);
    // setPageOffset(0);
    // setActivePage(1);
    consoleLog("page limit",pageLimit)
    StoreProductsApi(searchValue,(e.target.value),pageOffset);
  };

  const StoreProductsApi = async (searchValue,pageLimit,pageOffset) => {
    setIsLoading(true)
    // STORE_API_PATH.UNIQUE_STORE_PRODUCTS
    let apipath = searchValue != "" ? `Product/searchStoreProductList?storeId=${props.id}
      &categoryId=&keyword=${searchValue}&limit=${pageLimit}&offset=${pageOffset}` :

      `Product/newStoreProductList?storeId=${props.id}&categoryId=&limit=${pageLimit}&offset=${pageOffset}`
    let data = await axios.get(API_CONFIG.API_HOST + apipath, {
      headers: API_HEADERS
    })
    consoleLog(data.data)
    setIsLoading(false)
    if (data.data.result.result !== null) {
      setTotalCount(Number(data.data.result.total));
      setPageCount(Math.ceil((+(data.data.result.total) / pageLimit)));
      setProductList(data.data.result.result);
      setFilterList(data.data.result.result)
    }
  }

  // const storeProductSearch = async () => {
  //   let data = await axios.get(API_CONFIG.API_HOST + "Product/searchStoreProductList" + `?storeId=${props.id}
  //     &categoryId=&keyword=${searchValue}&limit=${pageLimit}&offset=${pageOffset}`, {
  //     headers: API_HEADERS
  //   })
  //   consoleLog("Product name search", data)
  //   setFilterList(data.data.result.result)
  // }

  // const searchResult = (e) => {
  //   setSearchValue(e.target.value)
  //   let term = e.target.value;
  //   consoleLog("search term",e.target.value)

  //   if (term !== "") {
  //     let data = productsList.filter((item) => {
  //       if (item.product_name.toLowerCase().includes(term.toLowerCase())) {
  //         return item;
  //       }
  //     });
  //     console.log("search result",data)
  //    setFilterList(data)
  //   } else {
  //     setFilterList(productsList);
  //   }

  //   // let data = productsList.filter(item => {
  //   //   if (item.product_name.toLowerCase().includes(term.toLowerCase())) {
  //   //     return item
  //   //   }
  //   // })
  //   // setFilterList(data)
  // }

  return (
    <>
      <div className='row d-flex flex-row justify-content-between'>
        <div className='col-12 col-lg-3 mb-3 d-flex flex-row'>
          
            <input type='text'
              className='form-control'
              placeholder='search by product name'
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)} />
         
            <button className='btn btn-primary' style={{marginLeft:5}} onClick={()=>{
              StoreProductsApi(searchValue,pageLimit,pageOffset)}}>Search</button>
          
        </div>
        {
          isSuperAdmin?<div className='col-12 col-lg-3 mb-3 d-flex flex-row justify-content-end'>
          <button className='btn btn-success' onClick={() => navigate("/uniqueStoreCategory", { state: { storeId: props.id } })}>
            Add Product
          </button>
        </div>:""
        }
      </div>
      <div className="row">


        <div className="col-md-12 card-1 h-scroll">
          <table className="table table-hover align-middle">
            <thead className="thead-dark">
              <tr id="Row1">
                <th scope="col">ID</th>
                <th Scope="col">Category</th>
                <th scope="col">Product Image</th>

                <th scope="col">Product Name</th>
                <th scope="col">QTY</th>
                {/* <th scope="col">UOM</th> */}
                <th scope="col">Whole Sale Price</th>
                <th scope="col">Sale Price</th>
                <th scope="col">Offer Price</th>
                <th scope="col" colSpan={2}>GST</th>
                <th scope="col">APP%</th>
                <th scope="col">Rating</th>
                {(!isFranchise && !isCustomerSupport && !isAccountent) && <>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </>}

              </tr>
              <tr id="Row2">
                <td></td>
                <td></td>
                <td></td>

                {/* <td></td> */}
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>

                <th scope="col">CGST%</th>
                <th scope="col">SGST%</th>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </thead>

            <tbody>
              {
                isLoading ? (
                  <>Loading</>
                ) :
                  filterList && filterList.length > 0 ? filterList.map((obj, i) => {
                    consoleLog("checking", obj)
                    return (

                      <ProductItem item={obj} key={obj.id} sno={i + 1} />
                    )
                  }) : (
                    <>No data</>
                  )

              }
            </tbody>

          </table>
          {console.log("pagecount", pageCount)}
          <AppPagination
            pageCount={pageCount}
            activePage={activePage}
            totalCount={totalCount}
            onPageChange={(page) => handlePageChange(page)}
            onLimitChange={(e) => handleLimitChange(e)}
          />
        </div>
      </div>

    </>
  )
}

export default UniqueStoreProducts